<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <h4 class="title header-tablepage">Setting Detail</h4>
      <b-tabs class="mt-4">
        <b-tab title="Form Setting">
          <div class="bg-white p-3">
            <div class="text-right">
              <b-dropdown
                id="dropdown"
                right
                class="btn-mobile mr-2"
                v-if="id == 0"
              >
                <template #button-content>
                  <span class="d-none d-md-inline-flex btn-text mr-1"
                    >Download Template
                    <font-awesome-icon icon="file-import" class="icon"
                  /></span>
                </template>

                <!-- <b-dropdown-item
                  v-for="item in templateList"
                  :key="`template-${item.id}`"
                  @click="downLoadTemplate(item.id)"
                >
                  {{ item.name }}
                </b-dropdown-item> -->
              </b-dropdown>
              <!-- <b-button
                v-if="id == 0"
                class="btn ml-2 btn-custom-outline-primary"
                @click="downLoadTemplate()"
                >Download Template
                <font-awesome-icon icon="file-import" class="icon" />
              </b-button> -->
            </div>

            <b-row>
              <b-col colas="12" md="6">
                <InputText
                  textFloat="Name"
                  v-model="form.name"
                  placeholder="name"
                  isRequired
                  :isValidate="$v.form.name.$error"
                  :v="$v.form.name"
                >
                </InputText>
              </b-col>
              <b-col md="6"></b-col>
              <b-col md="6" class="">
                <div :class="['div-input']">
                  <div
                    :class="[
                      'input-custom',
                      { error: $v.form.file_name.$error },
                    ]"
                  >
                    <label>
                      File Name
                      <span class="text-error">*</span>
                    </label>

                    <div class="d-flex align-items-start">
                      <InputUploadFile
                        textFloat=""
                        format="trdp"
                        id="Upload"
                        label="Upload File"
                        :fileName="form.file_name"
                        class="mb-0"
                        v-model="form.base64"
                        placeholder="File Name"
                        textUpload="Upload File"
                        text="Please Upload File Type .trdp"
                        hideOverlay
                        @delete="deleteImage()"
                        @onFileChange="onFileChange"
                        :isValidate="$v.form.file_name.$error"
                        :v="$v.form.file_name"
                      />
                      <b-button
                        :disabled="!form.file_name"
                        class="btn ml-2 btn-custom-outline-primary"
                        @click="downloadLayout()"
                        >Download Layout
                        <font-awesome-icon icon="file-import" class="icon" />
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col cols="6"></b-col>
              <b-col cols="6" class="mt-2">
                <InputText
                  textFloat="Sort order"
                  v-model="form.sort_order"
                  placeholder="Sort order"
                  type="number"
                  :isValidate="$v.form.sort_order.$error"
                  :v="$v.form.sort_order"
                  isRequired
                >
                </InputText>
              </b-col>
              <b-col cols="12" class="mt-2">
                <b-form-checkbox
                  switch
                  class="radio-active"
                  size="lg"
                  :value="1"
                  :unchecked-value="0"
                  v-model="form.is_active"
                >
                  <span class="ml-2 main-label">Active</span>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </div></b-tab
        >
      </b-tabs>
      <FooterAction routePath="/setting-non-serial" @submit="save()" />
    </div>
  </div>
</template>
<script>
import OtherLoading from "@/components/loading/OtherLoading.vue";
import { required } from "vuelidate/lib/validators";
import InputUploadFile from "@/components/inputs/UploadFileV2.vue";

export default {
  components: {
    OtherLoading,
    InputUploadFile,
  },

  data() {
    return {
      isLoading: false,
      form: {
        name: "",
        file_name: "",
        is_active: 0,
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        base64: "",
        setting_type_id: 2,
        sort_order: null,
      },
      templateList: [],
      id: this.$route.params.id,
    };
  },
  validations() {
    return {
      form: {
        name: { required },
        file_name: { required },
        sort_order: { required },
      },
    };
  },
  async created() {
    if (this.id > 0) {
      await this.getDetial();
    } else {
      await this.getListTemplate();
    }
  },
  methods: {
    async getDetial() {
      this.isLoading = true;
      const res = await this.axios(`/setting/get/${this.id}`);
      this.form = {
        ...res.data.detail,
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        setting_type_id: 2,
      };

      this.isLoading = false;
    },
    async save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      this.isLoading = true;
      if (this.id === "0") {
        const res = await this.axios.post(`/setting/create`, this.form);
        if (res.data.result) {
          this.successAlert();
          this.$router.push("/setting-non-serial");
        } else {
          this.errorAlert(res.data.message);
        }
      } else {
        const res = await this.axios.put(`/setting/update`, {
          ...this.form,
          base64: this.form.base64 ? this.form.base64 : "",
          file_name: this.form.file_name || "",
          id: this.id,
        });
        if (res.data.result) {
          this.successAlert();
          this.$router.push("/setting-non-serial");
        } else {
          this.errorAlert(res.data.message);
        }
        this.isLoading = false;
      }
    },
    async handleEdit() {
      if (this.id === "0") {
        window.open(
          `${process.env.VUE_APP_API_TEMPLATE}/webReportDesigner.html`,
          "_blank"
        );
      } else {
        window.open(
          `${process.env.VUE_APP_API_TEMPLATE}${this.form.url}`,
          "_blank"
        );
      }
    },
    deleteImage() {
      this.form.file_name = "";
      this.form.base64 = "";
    },
    onFileChange(file) {
      this.form.file_name = file.name;
      this.isDisable = false;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.base64 = reader.result;
      };
    },
    async downLoadTemplate(id) {
      const res = await this.axios.post(
        `/setting/DownloadTemplate`,
        { id: id },
        {
          responseType: "blob",
        }
      );

      const disposition = res.headers["content-disposition"];
      let fileName = `template-${id}.trdp`;
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }
      }

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    async getListTemplate() {
      const res = await this.axios(`/setting/GetDownloadTemplates`);
      this.templateList = res.data.detail;
    },
    async downloadLayout() {
      const res = await this.axios.post(
        `/setting/DownloadLayout`,
        { id: this.id },
        {
          responseType: "blob",
        }
      );

      const disposition = res.headers["content-disposition"];
      let fileName = this.form.file_name;
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }
      }

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>
<style scoped lang="scss">
input[type="file"] {
  display: none;
}
.detail-format {
  color: #9b9b9b;
  font-size: 12px;
  font-family: "Kanit-Light";
  margin-top: 3px;
  margin-bottom: 0px;
}
.bg-icon.fa-lg {
  margin: 8px 0px;
}
.div-input {
  position: relative;
  white-space: nowrap;
}
.input-custom {
  padding: 0px;
}

input.custom-input {
  color: var(--font-main-color);
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 0px;
  padding: 7px 10px;
}
label[size="lg"].btn-main,
input[size="lg"].custom-input {
  height: 45px;
}
.input-custom.error .custom-input {
  border-color: red !important;
}
::-webkit-input-placeholder {
  /* Edge */
  color: rgba(22, 39, 74, 0.4);
}
:-ms-input-placeholder {
  /* Internet Explorer */
  color: rgba(22, 39, 74, 0.4);
}
::placeholder {
  color: rgba(22, 39, 74, 0.4);
}
.custom-input {
  display: block;
  border: none;
  width: 100%;
}
.text-desc {
  color: var(--font-main-color);
  font-size: 15px;
  font-family: "Kanit-Light";
}
.display-only {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.btn-main {
  width: 120px;
  text-align: center;
  height: 35px;
  vertical-align: middle;
  cursor: pointer;
  background: var(--font-main-color);
  color: white;
  padding: 7px 10px;
  border-radius: 0px 0.25rem 0.25rem 0px;
}
.btn-download-file {
  padding: 0;
  text-decoration: underline;
}
.delete-icon {
  position: absolute;
  right: 5%;
  top: 10px;
}
.text-error {
  color: red;
}
@media (max-width: 767.98px) {
  .detail-format {
    font-size: 11px;
  }
}
.input-custom input {
  color: var(--font-main-color);
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem 0 0 0.25rem;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  width: 100%;
}
.error input {
  border-color: red;
}
</style>
